import { Navigate, useLocation, useParams } from 'react-router-dom';

import { useApp } from '@backstage/core-plugin-api';

import {
  ResourceAliasMap,
  resolveResourceAliasTarget,
} from '@spotify/confidence-core-react';

export interface ResourceAliasRouteProps {
  aliases: ResourceAliasMap;
}

export const ResourceAliasRoute = ({ aliases }: ResourceAliasRouteProps) => {
  const { resource, '*': subPath } = useParams();
  const { search, hash } = useLocation();
  const { NotFoundErrorPage } = useApp().getComponents();

  const target = resource
    ? resolveResourceAliasTarget(aliases, resource)
    : undefined;

  if (!target) {
    return <NotFoundErrorPage />;
  }

  const suffix = subPath ? `/${subPath}` : '';

  return <Navigate to={`${target}${suffix}${search}${hash}`} replace  data-track-source-anchor="6342f52033;resource-alias-route-navigate"/>;
};
